// removed by extract-text-webpack-plugin
module.exports = {"banner":"Banner-module__banner___2PxLH","no-image":"Banner-module__no-image___c-mhl","mobile":"Banner-module__mobile___3cAOg"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Banner/Banner.module.scss
// module id = 168
// module chunks = 0 1